import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable, Subscription } from 'rxjs';
import { HttpAppRoleService } from '../../service/http-app-role.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AbstractAuditDto, AppRoleDto } from '../../service/dto';
import { HttpAuditService } from '../../service/http-audit.service';

@Component({
	selector: 'app-role-edit',
	standalone: false,
	templateUrl: './role-edit.component.html',
	styleUrl: './role-edit.component.scss'
})
export class RoleEditComponent {
	roleId?: number;
	roleForm!: FormGroup;
	selectedTabIndex = 0;
	modifications!: Observable<AbstractAuditDto[]>;

	loading = false;
	submitting = false;
	subscription = new Subscription();
	mode: 'New' | 'Edit' = 'New';

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private roleService: HttpAppRoleService,
		private activatedRoute: ActivatedRoute,
		private auditService: HttpAuditService,
		private messageService: NzMessageService) {
	}
	ngOnInit(): void {
		this.subscription.add(
			this.activatedRoute.paramMap.subscribe(params => {
				const roleId = params.get('roleId');
				this.roleId = +(roleId ?? '0');
				if (roleId) {
					this.mode = 'Edit';
					this.roleService.get(+roleId).subscribe(result => {
						this.roleForm = this.fb.group({
							name: [result.name, Validators.required],
							description: [result.description, Validators.required],
						});
					});
					this.modifications = this.auditService.getModificationsToAppRole(this.roleId,0,1000).pipe(
						map(item => item.records as AbstractAuditDto[])
					);
				} else {
					this.mode = 'New';
					this.roleForm = this.fb.group({
						name: ['', Validators.required],
						description: ['', Validators.required],
					});
				}
			})
		);
	}

	doSubmit() {
		const payload: AppRoleDto = {
			id: 0,
			createdAt: new Date(),
			name: this.roleForm.get('name')?.value,
			description: this.roleForm.get('description')?.value,
			permissions:[],
			hashCode: 0
		};
		if (this.mode == 'New') {
			this.roleService.createRole(payload).subscribe(result => {
				this.messageService.info('Role created');
				this.router.navigate(['/role', 'list']);
			});
		} else {
			this.roleService.editRole(this.roleId!, payload).subscribe(result => {
				this.messageService.info('Role updated');
				this.router.navigate(['/role', 'list']);
			});
		}
	}
}
